import {useContext, useEffect} from "react";
import CartContext from "../context/useCartContext";

const useCartHook = () =>{
    return useContext(CartContext);
}
export default useCartHook;